export type HealthManagementMode = 'complex' | 'manufacturer_lifespan' | null | undefined;

type HealthParameterInput = {
  dpEul?: number | string | null;
  dpBeta?: number | string | null;
  manufacturerLifespan?: number | string | null;
  commissionedDate?: string | Date | null;
  installationDate?: string | Date | null;
  startDate?: string | Date | null;
};

const toPositiveNumber = (value: number | string | null | undefined): number | null => {
  if (value === null || value === undefined) {
    return null;
  }
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }
  return parsed;
};

const hasValidDate = (value: string | Date | null | undefined): boolean => {
  if (!value) {
    return false;
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isFinite(date.getTime());
};

const hasCommissionedLikeDate = (input: HealthParameterInput): boolean =>
  hasValidDate(input.commissionedDate) || hasValidDate(input.installationDate) || hasValidDate(input.startDate);

export const hasComplexHealthParameters = (input: HealthParameterInput): boolean => {
  const dpEul = toPositiveNumber(input.dpEul);
  const dpBeta = toPositiveNumber(input.dpBeta);
  return dpEul !== null && dpBeta !== null && hasCommissionedLikeDate(input);
};

export const hasManufacturerHealthParameters = (input: HealthParameterInput): boolean => {
  const manufacturerLifespan = toPositiveNumber(input.manufacturerLifespan);
  return manufacturerLifespan !== null && hasCommissionedLikeDate(input);
};

export const hasRequiredHealthParameters = (
  mode: HealthManagementMode,
  input: HealthParameterInput,
): boolean => {
  const hasComplex = hasComplexHealthParameters(input);
  const hasManufacturer = hasManufacturerHealthParameters(input);

  if (mode === 'manufacturer_lifespan') {
    return hasManufacturer;
  }
  if (mode === 'complex') {
    return hasComplex;
  }
  // フォールバック: モード未取得/不整合時は誤って ???% にならないよう緩和
  return hasComplex || hasManufacturer;
};
